module.exports = __webpack_public_path__ + "img/00019.a901b93d.webp";